export const CLI_PAYMENT_TYPES = [
  "DO",
  "HYPHEN",
  "DEBI_CHECK",
  "EASY_PAY",
]

export const FUNERAL_PAYMENT_TYPES = [
  "DO",
  "DEBI_CHECK",
  "EASY_PAY",
  "MONEYMARKET"
]

// Payment methods allowed for OMAS-sourced (accountingIdentifier === "OMAS") funeral policies
export const OMAS_FUNERAL_PAYMENT_TYPES = [
  "DO",
  "PERSAL",
  "DOD",
  "SASSA"
]

// Payroll-deduction payment types: no bank account/debit order, paid via a payroll mandate
// (payroll number + employee number) instead - see QlinkMandate.js
export const PAYROLL_PAYMENT_TYPES = [
  "QLINK",
  "PERSAL",
  "DOD",
  "SASSA"
]

//full list 
// export const PAYMENT_TYPES = [
//   "PAY_AT",
//   "NAEDO",
//   "DO",
//   "FROM_SAVINGS",
//   "QLINK",
//   "HYPHEN",
//   "DEBIT_ORDER",
//   "EFT",
//   "SDV",
//   "ONEDAY",
//   "TWODAY",
//   "SAMEDAY",
//   "DEBI_CHECK",
//   "EMPLOYER",
//   "EASYPAY",
//   "MONEYMARKET"
// ]